module.exports = __webpack_public_path__ + "static/media/kredyt_5.ff1f212b.png";